import { Dropdown, Select, Space } from "antd";
import React from "react";
import type { MenuProps } from "antd";
import Avatar from "../../assets/images/avatar.png";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import flagEn from "../../assets/images/flags/en.png";
import flagRu from "../../assets/images/flags/ru.png";
import flagUz from "../../assets/images/flags/uz.png";
import LogoutButton from "../logout_button";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../store";
import { FILE_URL } from "../../config/utils";
import Arbitrator_new_logo_eng from '../../assets/images/new-logo-blue.svg';
import Arbitrator_new_logo_ru from '../../assets/images/new-logo-ru-blue.svg';
import Arbitrator_new_logo_uz from '../../assets/images/new-logo-uz-blue.svg';

const ProfileHeader: React.FC = () => {
  const { t } = useTranslation();
  const about_me = useAppSelector((state) => state?.about_me);
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <Link to={"/my-information"}> {t("Profile")} </Link>,
    },
    {
      key: "2",
      label: (
        <span className="hover:cursor-pointer">
          <LogoutButton />
        </span>
      ),
    },
  ];

  const handleChange = (value: { value: string; label: React.ReactNode }) => {
    localStorage.setItem("i18lang", `${value?.value}`);
    i18next.changeLanguage(value.value);
  };

  const active_lang = localStorage.getItem('i18lang');

  return (
    <div className="w-full py-2 px-3  border-b-2 border-[#9ed0f0] flex items-center">
      <div className="flex w-full items-center justify-between">
        <Link to={"/"}>
        <img src={active_lang == 'uz' ? Arbitrator_new_logo_uz : active_lang == 'ru' ? Arbitrator_new_logo_ru : Arbitrator_new_logo_eng} alt="logo" width={170} height={80} />
        </Link>
        <div className="flex items-center justify-end sm:gap-5 gap-2">
          <Link to={"/"} className="rounded-md bg-main_color text-white text-center flex items-center px-5 py-1 font-semibold" >{t("Dashboard")}</Link>
        <Select
          labelInValue
          style={{ width: 85 }}
          defaultValue={localStorage.getItem("i18lang") ?? ("uz" as any)}
          onChange={handleChange}
          options={[
            {
              value: "uz",
              label: (
                <span className="flex items-center max-sm:text-xs">
                  <img
                    src={flagUz}
                    alt="flag"
                    className="w-[25px] h-[20px] mr-2"
                  />{" "}
                  UZ
                </span>
              ),
            },
            {
              value: "en",
              label: (
                <span className="flex items-center max-sm:text-xs">
                  <img
                    src={flagEn}
                    alt="flag"
                    className="w-[25px] h-[20px] mr-2"
                  />{" "}
                  EN
                </span>
              ),
            },
            {
              value: "ru",
              label: (
                <span className="flex items-center max-sm:text-xs">
                  <img
                    src={flagRu}
                    alt="flag"
                    className="w-[25px] h-[20px] mr-2"
                  />{" "}
                  RU
                </span>
              ),
            },
          ]}
        />
        <Dropdown
          menu={{ items }}
          className="sm:w-[200px] block border-l-2 border-[#CECECE]"
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <div className="flex hover:cursor-pointer hover:bg-gray-100 py-2 sm:px-4 max-sm:pl-2 hover:rounded-full">
                {about_me?.about_me &&
                about_me?.about_me?.avatar?.contentUrl ? (
                  <img
                    src={`${FILE_URL}${
                      about_me?.about_me &&
                      about_me?.about_me?.avatar?.contentUrl
                    }`}
                    alt="avatar"
                    className="w-[48px] h-[48px] rounded-[50%]"
                  />
                ) : (
                  <img src={Avatar} alt="Avatar" />
                )}
                <div className="ml-2 max-sm:hidden">
                  <h4 className="text-[14px] font-semibold">
                    {about_me?.about_me?.lastName}{" "}
                    {String(about_me?.about_me?.firstName).charAt(0)}.
                  </h4>
                  <span className="text-[12px] font-semibold">
                    {t(`${about_me?.about_me?.user?.roles[0]}`)}
                  </span>
                </div>
              </div>
            </Space>
          </a>
        </Dropdown>
        </div>

      </div>
    </div>
  );
};

export default ProfileHeader;
